(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-collection-pills"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-collection-pills')) {
    customElements.define('ct-collection-pills', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          const list = this.querySelector('.ct-collection-pills__list');
          const active = this.querySelector('[aria-current="page"]');
          if (!list || !active || !this.getClientRects().length) return;
          const listBox = list.getBoundingClientRect();
          const activeBox = active.getBoundingClientRect();
          list.scrollLeft += activeBox.left - listBox.left - (list.clientWidth - activeBox.width) / 2;
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
